const transformBundleOptions = (bundle_options)=>{
    if (!bundle_options) {
        return null;
    }
    return bundle_options.map(({ option_id , option_qty , option_selections  })=>({
            id: option_id,
            selections: option_selections.map((selection)=>({
                    id: selection,
                    qty: option_qty
                }))
        })).reduce((acc, { id , selections  })=>{
        const justAdded = acc.find(({ id: idExists  })=>idExists === id);
        if (justAdded) {
            justAdded.selections = [
                ...justAdded.selections,
                ...selections
            ];
        } else {
            acc.push({
                id,
                selections: [
                    ...justAdded?.selections ?? [],
                    ...selections
                ]
            });
        }
        return acc;
    }, []);
};
const transformBundleOptionsRequest = (bundle_options)=>{
    return bundle_options.reduce((options, { id: optionId , selections  })=>{
        return options.concat(selections.map(({ id , qty  })=>id ? {
                option_id: optionId,
                option_qty: qty,
                option_selections: [
                    id
                ]
            } : null));
    }, []);
};

export { transformBundleOptions, transformBundleOptionsRequest };
